export var DropType = {
    CENTER: 0,
    TOP: 1,
    BOTTOM: 2,
};
export function modifyClassType(el, type) {
    el.classList.remove('drag-over-bottom');
    el.classList.remove('drag-over-top');
    el.classList.remove('drag-over-center');
    el.classList.remove('drag-target');
    switch (type) {
        case DropType.TOP:
            el.classList.add('drag-over-top');
            break;
        case DropType.BOTTOM:
            el.classList.add('drag-over-bottom');
            break;
        case DropType.CENTER:
            el.classList.add('drag-over-center');
            break;
        default:
            break;
    }
}
export default {
    DropType: DropType,
    modifyClassType: modifyClassType,
};
